"use client";

import { type ReactNode } from "react";
import { Minus, Plus } from "lucide-react";
import { AccordionContent, AccordionItem, AccordionTrigger } from "./accordion";
import { Typography } from "./typography";

type Props = {
  value: string;
  /** The question / toggle title rendered in the trigger row. */
  question: ReactNode;
  children: ReactNode;
};

/**
 * A styled accordion item with a circular Plus/Minus icon toggle, matching
 * the FAQ design used across the marketing site.
 */
export const FaqAccordionItem = ({ value, question, children }: Props) => (
  <AccordionItem value={value} className="group transition-colors">
    <AccordionTrigger
      className="gap-2 py-2 hover:no-underline sm:py-3 [&[data-state=open]>svg]:rotate-0"
      icon={
        <div className="group-hover:bg-primary-500 relative flex size-3.5 shrink-0 items-center justify-center rounded-full border border-neutral-500 bg-white transition-colors group-hover:border-0">
          <Plus
            size={12}
            className="absolute scale-100 text-black opacity-100 transition-all duration-200 group-hover:text-white group-data-[state=open]:scale-0 group-data-[state=open]:opacity-0"
            aria-hidden
          />
          <Minus
            size={12}
            className="absolute scale-0 text-black opacity-0 transition-all duration-200 group-hover:text-white group-data-[state=open]:scale-100 group-data-[state=open]:opacity-100"
            aria-hidden
          />
        </div>
      }
    >
      <Typography className="text-sm sm:text-lg" weight="semibold" color="black">
        {question}
      </Typography>
    </AccordionTrigger>
    <AccordionContent className="pb-2 sm:pb-3">{children}</AccordionContent>
  </AccordionItem>
);
